const ImageBlockRender = ({ image, link }: { image: string, link: string }) => {
    return (
        <div>
            {link ?
                <a href={link} target="_blank" className="block">
                    <img src={image} alt="Obraz" className="w-full h-auto my-12" />
                </a>
                :
                <img src={image} alt="Obraz" className="w-full h-auto my-12" />
            }
        </div>
    )
}

export default ImageBlockRender;